import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { zooplaTheme as theme } from '@blueprint/theme';

type Theme = {
    theme: typeof theme;
};

const BaseStyles = ({ theme }: Theme) => css`
    display: flex;
    align-items: center;
    border: none;
    border: 1px solid ${theme.colors['graphic-background-accent']};
    padding: calc(${theme.spacing['16px']} + ${theme.spacing['2px']})
        ${theme.spacing['16px']};
    padding-right: ${theme.spacing['24px']};
    color: ${theme.colors['text-title']};
    background: ${theme.colors.white};
    cursor: pointer;
    text-decoration: none;
    margin: 0;

    &:focus {
        box-shadow: ${theme.focusRing};
        outline: 0;
    }

    svg {
        flex-shrink: 0;

        &:first-of-type {
            color: ${theme.colors['primary-brand']};
        }
    }
`;

export const ContainerButton = styled('button')(BaseStyles);
export const ContainerLink = styled('a')(BaseStyles);

export const Label = styled('span')(
    ({ theme: { fontWeight } }) => css`
        display: block;
        width: 100%;
        overflow: hidden;
        font-family: Lato, Helvetica, Arial, sans-serif;
        font-size: ${theme.type['body']};
        font-weight: ${fontWeight['bold']};
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        padding-left: ${theme.spacing['8px']};
        padding-right: ${theme.spacing['8px']};
    `
);
